<!-- <div *ngIf="isCloseDetailClicked || selectedItemForView == selectedItem[3]">
  <app-account-list-template [accountList]="accountList" (selectedAccountEmitter)="selectedItemToView($event)"
    (selectedAccountCloseEmitter)="closeViewItem($event)" #accountListTemplate></app-account-list-template>
</div>

<div *ngIf="isCloseDetailClicked || selectedItemForView == selectedItem[1]">
  <app-service-package-list-template [servicePackageList]="servicePackageList"
    (selectedServicePackageEmitter)="selectedItemToView($event)"
    (selectedServicePackageCloseEmitter)="closeViewItem($event)" #servicePackageListTemplate>
  </app-service-package-list-template>
</div>

<div *ngIf="isCloseDetailClicked || selectedItemForView == selectedItem[0]">
  <app-service-list-template [services]="services" (selectedServiceEmitter)="selectedItemToView($event)"
    (selectedServiceCloseEmitter)="closeViewItem($event)" #serviceListTemplate>
  </app-service-list-template>
</div> -->
<div class="mb-2 mt-2">
  <span>Found&nbsp;</span>
  <span *ngIf="servicePackageList && servicePackageList.length > 0">
      <b>{{servicePackageList.length}}&nbsp;</b>
      <a class="font16-400-link-black" href="#servicePackageDiv">service package<span *ngIf="servicePackageList.length > 1">s</span></a>
  </span>
  <span *ngIf="locationList && locationList.length > 0">
      <span *ngIf="(servicePackageList && servicePackageList.length > 0)">,&nbsp;</span>
      <b>{{locationList.length}}&nbsp;</b>
      <a class="font16-400-link-black" href="#locationDiv">location<span *ngIf="locationList.length > 1">s</span></a>
  </span>
  <span *ngIf="vehicleList && vehicleList.length > 0">
      <span *ngIf="(servicePackageList && servicePackageList.length > 0) || (locationList && locationList.length > 0)">,&nbsp;</span>
      <b>{{vehicleList.length}}&nbsp;</b>
      <a class="font16-400-link-black" href="#vehicleDiv">vehicle<span *ngIf="vehicleList.length > 1">s</span></a>
  </span>
  <span *ngIf="usageList && usageList.length > 0">
    <span *ngIf="(servicePackageList && servicePackageList.length > 0) || (locationList && locationList.length > 0) || (vehicleList && vehicleList.length > 0)">,&nbsp;</span>
    <b>{{usageList.length}}&nbsp;</b>
    <a class="font16-400-link-black" href="#usageDiv">Usage</a>
  </span>
  <span *ngIf="userList && userList.length > 0">
    <b>{{userList.length}}&nbsp;</b>
    <a class="font16-400-link-black" href="#userDiv">User</a>
  </span>
</div>

<div id="servicePackageDiv" *ngIf="isCloseDetailClicked || selectedItemForView == selectedItem[1]">
  <app-service-package-list-template [servicePackageList]="servicePackageList"
    (selectedServicePackageEmitter)="selectedItemToView($event)"
    (selectedServicePackageCloseEmitter)="closeViewItem($event)" #servicePackageListTemplate>
  </app-service-package-list-template>
</div>

<div id="locationDiv" *ngIf="isCloseDetailClicked || selectedItemForView == selectedItem[3]">
  <app-location-list-template [locationList]="locationList" #locationListTemplate></app-location-list-template>
</div>

<div id="vehicleDiv" *ngIf="isCloseDetailClicked || selectedItemForView == selectedItem[2]">
  <app-vehicle-list-template [vehicleList]="vehicleList" (selectedVehicleEmitter)="selectedItemToView($event)"
    (selectedVehicleCloseEmitter)="closeViewItem($event)" #vehicleListTemplate></app-vehicle-list-template>
</div>

<div id="usageDiv" *ngIf="usageList && usageList.length > 0 && (isCloseDetailClicked || selectedItemForView == selectedItem[4])">
  <app-view-service-usage [usageData]="usageList" [locationMap]="locationMap" #usageListTemplate></app-view-service-usage>
</div>

<div id="userDiv" *ngIf="userList && userList.length > 0 && (isCloseDetailClicked || selectedItemForView == selectedItem[5])">
  <app-user-list-template [admins]="userList" (selectedUserEmitter)="selectedItemToView($event)"
    (selectedUserCloseEmitter)="closeViewItem($event)" #userListTemplate></app-user-list-template>
</div>